import { addRelationHandler } from './AddRelationStmt';
import { onDeleteHandler } from './OnDeleteStmt';
import { removeRelationHandler } from './RemoveRelationStmt';
import { removeTranslatableRelationHandler } from './RemoveTranslatableRelationStmt';
import { setTranslatableRelationHandler } from './SetTranslatableRelationStmt';
export * from './AddRelationStmt';
export * from './OnDeleteStmt';
export * from './relationshipInstruction';
export * from './RemoveRelationStmt';
export * from './SetTranslatableRelationStmt';
export * from './RemoveTranslatableRelationStmt';
export const relationHandlers = [addRelationHandler, onDeleteHandler, removeRelationHandler, setTranslatableRelationHandler, removeTranslatableRelationHandler];
//# sourceMappingURL=index.js.map